import { DEV__TOGGLE_ON_BACKGROUND_OFFLINE } from "../types/types"

export const toggleOnBackgroundOffline = (enabled) => (dispatch) => {
  dispatch({
    type: DEV__TOGGLE_ON_BACKGROUND_OFFLINE,
    enabled,
  })
}
